import Vue from 'vue';
import type { TooltipConfig } from './types';
import { TooltipDirection, TooltipPosition } from './types';

export const events = new Vue({ name: 'BravadoTooltipEvents' });

export const getTooltipPosition = (el: HTMLElement, tooltipConfig: TooltipConfig): Record<string, string> => {
  const { width, top, left, bottom } = el.getBoundingClientRect();
  const { direction, position, variant } = tooltipConfig;

  const DISTANCE_FROM_VERTICAL_EDGE = 4;
  const DISTANCE_FROM_HORIZONTAL_EDGE = 24;
  const ARROW_HEIGHT = variant ? 8 : 0;

  const directionShift = {
    [TooltipDirection.Top]: top - DISTANCE_FROM_VERTICAL_EDGE - ARROW_HEIGHT,
    [TooltipDirection.Bottom]: bottom + DISTANCE_FROM_VERTICAL_EDGE + ARROW_HEIGHT,
  };

  const positionShift = {
    [TooltipPosition.Left]: `calc(-100% + ${DISTANCE_FROM_HORIZONTAL_EDGE}px)`,
    [TooltipPosition.Right]: `-${DISTANCE_FROM_HORIZONTAL_EDGE}px`,
    [TooltipPosition.Center]: '-50%',
  };

  return {
    top: `${directionShift[direction]}px`,
    left: `calc(${left}px + ${width / 2}px)`,
    transform: `translate(${positionShift[position]}, ${direction === TooltipDirection.Top ? '-100%' : '0'})`,
  };
};
